import React from 'react';

export default function PictoJapanese40() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_840_782)">
        <rect x="10" y="18" width="8" height="9" fill="#DAD8D2" />
        <path
          d="M24.6667 18C26.6668 18 30 18 30 18V27C30 27 24.6666 27 22 27C24.6667 24.4286 26.5 22.5 24.6667 18Z"
          fill="#DAD8D2"
        />
        <rect x="1" y="28" width="38" height="4" fill="#DAD8D2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3829 27.949C20.5848 27.9756 20.7906 27.992 21 27.9977V28H21.1671H31H31.8329C36.5732 28 39.5359 22.5238 37.1658 18.1429L31.8329 8.28572C29.4627 3.90476 23.5372 3.90476 21.1671 8.28571L20.3829 9.73504L20.9635 10.7635L22.0466 8.76156C24.0387 5.07948 28.9613 5.07948 30.9533 8.76156L36.2862 18.6187C38.348 22.4296 35.7089 27 31.8329 27H31V19C31 17.8954 30.1045 17 29 17H24.4843L25.0489 18H29C29.5522 18 30 18.4477 30 19V27H22.9892C22.2277 27.4921 21.3484 27.8271 20.3829 27.949Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.2587 18.6345L18.694 8.77733C16.6034 5.07422 11.3966 5.07422 9.30604 8.77733L3.74127 18.6345C1.62546 22.3823 4.29244 27 8.43523 27H19.5648C23.7076 27 26.3745 22.3823 24.2587 18.6345ZM19.5648 8.28572C17.0915 3.90476 10.9085 3.90476 8.43523 8.28571L2.87046 18.1429C0.397228 22.5238 3.48877 28 8.43523 28H19.5648C24.5112 28 27.6028 22.5238 25.1295 18.1429L19.5648 8.28572Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 18H11C10.4477 18 10 18.4477 10 19V27H18V19C18 18.4477 17.5523 18 17 18ZM11 17C9.89543 17 9 17.8954 9 19V28H19V19C19 17.8954 18.1046 17 17 17H11Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38 28H2C1.44772 28 1 28.4477 1 29V31C1 31.5523 1.44772 32 2 32H38C38.5523 32 39 31.5523 39 31V29C39 28.4477 38.5523 28 38 28ZM2 27C0.895431 27 0 27.8954 0 29V31C0 32.1046 0.895431 33 2 33H38C39.1046 33 40 32.1046 40 31V29C40 27.8954 39.1046 27 38 27H2Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 33H5V34C5 34.5523 5.44772 35 6 35H8C8.55228 35 9 34.5523 9 34V33ZM4 32V34C4 35.1046 4.89543 36 6 36H8C9.10457 36 10 35.1046 10 34V32H4Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36 33H32V34C32 34.5523 32.4477 35 33 35H35C35.5523 35 36 34.5523 36 34V33ZM31 32V34C31 35.1046 31.8954 36 33 36H35C36.1046 36 37 35.1046 37 34V32H31Z"
          fill="#142138"
        />
      </g>
      <defs>
        <clipPath id="clip0_840_782">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
